import React, { useEffect } from 'react';

import useVersion from '../hooks/useVersion';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  useVersion();

  // disappear widgets in dashboard layout

  document?.getElementById('ps_w')?.remove();
  window?.parent?.document?.getElementById('ps_w')?.remove();

  useEffect(() => {
    document?.getElementById('ps_w')?.remove();
    window?.parent?.document?.getElementById('ps_w')?.remove();
  }, [location.pathname]);

  return <div className="auth-layout tw-min-h-screen">{children}</div>;
};

export default AuthLayout;
